import { DatePicker, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from 'recharts';

import Icon from 'utils/icon';

import styles from './transaction.module.scss';

function TransactionComponent({ data }: { data: any }) {
	const { RangePicker } = DatePicker;

	return (
		<div className={styles.transactions}>
			<header>
				<h5>Transaction History</h5>
				<RangePicker
					size="large"
					inputReadOnly
					maxDate={dayjs(new Date())}
					format="DD MMM YYYY"
					suffixIcon={<Icon name="calendar" />}
					separator="-"
				/>
			</header>
			<main>
				<h2>
					12,706
					<span className="status active">
						<Icon name="upArrow" width={10} height={10} />
						2.2%
					</span>
				</h2>
			</main>

			<div className={styles.chart}>
				<ResponsiveContainer>
					<AreaChart data={data} margin={{ top: 20, right: 0, left: -25, bottom: 20 }}>
						<defs>
							<linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
								<stop offset="0%" stopColor="#3E97FF" stopOpacity={0.4} />
								<stop offset="100%" stopColor="#3E97FF" stopOpacity={0} />
							</linearGradient>
						</defs>
						<XAxis dataKey="name" />
						<YAxis />
						<CartesianGrid strokeDasharray={3} vertical={false} />
						<Tooltip />
						<Area type="bumpX" dataKey="uv" stroke="#3E97FF" fillOpacity={1} strokeWidth={2} fill="url(#colorUv)" />
					</AreaChart>
				</ResponsiveContainer>
			</div>
		</div>
	);
}

export default TransactionComponent;
